<template>
  <div>
    <div class="unitbox">
      <!-- <el-input v-model="unitAbbreviation" placeholder="选择单位" readonly /> -->
      <el-autocomplete
        id="autocomplete"
        ref="autocomplete"
        v-model="currentSearch"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入内容"
        @select="handleSelect"
        @blur="blurFun"
        style="flex: 1;margin-right:5px"
        :popper-append-to-body="false"
      ></el-autocomplete>
      <!--      @keyup.enter.native="enterFun" -->
      <el-button type="primary" @click="onunitDialog">请选择</el-button>
    </div>
    <unit-dialog
      ref="unitDialog"
      in-dialog
      selectable
      @select="setUnit"
      title="供应商列表"
      :typeList="[1,2]"
    />
  </div>
</template>
<script>
import unitDialog from "@/components/purchase/supplier/archives/listDialog";
export default {
  components: {
    unitDialog,
  },
  props: {
    value: {},
    state: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentSearch: this.state,
      restaurants: [],
      timeout: null,
      api: require("@/api/ba/tradeUnit").default,
    };
  },
  watch: {
    state() {
      this.currentSearch = this.state;
    },
  },
  computed: {},
  methods: {
    enterFun() {
      if (this.restaurants.length > 0) {
        this.currentSearch = this.restaurants[0].TradeUnitName;
        let obj = {
          value: this.restaurants[0].TradeUnitName,
          Id: this.restaurants[0].TradeUnitName,
          Name: this.restaurants[0].TradeUnitName,
        };
        this.$emit("restaurants", obj);
        this.$refs.autocomplete.suggestions = [];
      }
    },
    onunitDialog() {
      this.$refs.unitDialog.open().then((that) => {
        that.getData({});
        that.getTree();
      });
    },
    setUnit(cus) {
      // this.currentSearch = cus.TradeUnitName;
      // console.log('this.currentSearch', this.currentSearch)
      // let obj = {
      //   value: cus.TradeUnitName,
      //   Id: cus.TradeUnitId,
      //   Name: cus.TradeUnitName,
      // };
      this.$emit("restaurants", cus);
    },
    querySearchAsync(queryString, cb) {
      this.api
        .list2({ pageIndex: 1, pageSize: 10, TradeUnitType: 2, TradeUnitName: queryString,  })
        .then((res) => {
          this.restaurants = [];
          res.Data.forEach((e) => {
            e.value = e.TradeUnitName;
            this.restaurants.push(e);
          });
          // console.log("arr", this.restaurants);
          cb(this.restaurants);
        });
    },
    handleSelect(item) {
      this.$emit("restaurants", item)
      this.$emit("editrestaurants", (value) => {
        this.currentSearch = value
      })

    },
    blurFun(item) {
      // if (!this.currentSearch) {
        // this.$emit("restaurants", item);
      // }
    },

  },
};
</script>
<style lang="less" scoped>
::v-deep .el-autocomplete-suggestion{
  width: auto!important;
}
.unitbox {
  width: 100%;
  display: flex;
}
</style>
